export default "__VITE_ASSET__BryyN6CH__"